import gql from 'graphql-tag';
import FieldsCompany from 'graphql/fields/FieldsCompany'
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'active': '[String]',
};

export default gql(`
	query companies( ${ HelperGraphql.createFields( fields ) } ) {
		companies( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsCompany}
		}
	}
`);